export default __webpack_public_path__ + "static/media/default-movie-poster.3f971516.jpg";